// Persist an intended post-login destination across the login flow, including
// the OAuth full-page roundtrip (which discards React Router location state).
// Mirrors the existing `oauth_anonymous_user_id` localStorage handoff used by
// the OAuth buttons. A short TTL keeps an abandoned redirect from hijacking an
// unrelated future login.

const STORAGE_KEY = 'postLoginRedirect';
const TTL_MS = 30 * 60 * 1000; // 30 minutes

export const setPostLoginRedirect = (path) => {
  if (!path || typeof path !== 'string') return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ path, ts: Date.now() }),
    );
  } catch (e) {
    /* localStorage unavailable (private mode, quota); non-fatal */
  }
};

// Read and clear the stored redirect. Returns the path string, or null when
// absent, malformed, or older than the TTL.
export const consumePostLoginRedirect = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    localStorage.removeItem(STORAGE_KEY);
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.path !== 'string') return null;
    if (typeof parsed.ts === 'number' && Date.now() - parsed.ts > TTL_MS) {
      return null;
    }
    return parsed.path;
  } catch (e) {
    return null;
  }
};
